import script from "./UnsubscribeEmails.vue?vue&type=script&setup=true&lang=js"
export * from "./UnsubscribeEmails.vue?vue&type=script&setup=true&lang=js"

import "./UnsubscribeEmails.vue?vue&type=style&index=0&id=2b601298&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2b601298"]])

export default __exports__